var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "sidebar"
    },
    [
      _c(
        "div",
        {
          staticClass: "transparent navigation navigation--v2"
        },
        [
          _c("app-logo", {
            staticClass: "mb-5 pl-4"
          }),
          _c(
            "v-list",
            {
              ref: "scrollbar",
              staticClass: "ps-sidebar"
            },
            [
              _vm._l(_vm.menuToUse, function(item, k) {
                return [
                  item.items
                    ? [
                        _c(
                          "v-list-group",
                          {
                            key: item.title,
                            attrs: {
                              ripple: false,
                              "prepend-icon": "",
                              "no-action": "",
                              "append-icon": "",
                              group: item.group
                            },
                            on: {
                              click: function click($event) {
                                _vm.selectedMenu = k
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function fn() {
                                    return [
                                      _c(
                                        "v-list-item",
                                        {
                                          staticClass: "my-2 menu-parent",
                                          attrs: {
                                            ripple: false,
                                            "active-class": "navigation-active"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                [
                                                  item.action
                                                    ? _c("v-icon", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.action
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    {
                                                      class: [
                                                        item.active
                                                          ? "font-weight-bold"
                                                          : "font-weight-medium",
                                                        "fs-14"
                                                      ]
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.textTruncate(
                                                              item.title
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-action",
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.active
                                                        ? "mdi-chevron-down"
                                                        : "mdi-chevron-right"
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: item.active,
                              callback: function callback($$v) {
                                _vm.$set(item, "active", $$v)
                              },
                              expression: "item.active"
                            }
                          },
                          [
                            _vm._l(
                              item.items.filter(function(i) {
                                return !i.hidden
                              }),
                              function(subItem) {
                                return [
                                  !subItem.external
                                    ? _c(
                                        "v-list-item",
                                        {
                                          key: _vm.serviceId + subItem.title,
                                          attrs: {
                                            exact: subItem.exact,
                                            "active-class": "navigation-active",
                                            to: subItem.to,
                                            ripple: false
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            {
                                              staticStyle: {
                                                display: "block"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticClass: "ml-3",
                                                  staticStyle: {
                                                    display: "inline",
                                                    "font-size":
                                                      "13px !important"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "pr-0 mr-0"
                                                    },
                                                    [_vm._v("mdi-circle-small")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.textTruncate(
                                                          subItem.title
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-list-item",
                                        {
                                          key: subItem.title,
                                          attrs: {
                                            exact: subItem.exact,
                                            ripple: false,
                                            href: subItem.to,
                                            target: "_blank"
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.menuClick(
                                                subItem.onClick,
                                                [
                                                  _vm.serviceId,
                                                  _vm.$route.query.user
                                                ]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticClass: "ml-3",
                                                  staticStyle: {
                                                    "font-size":
                                                      "13px !important"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "pr-0 mr-0"
                                                    },
                                                    [_vm._v("mdi-circle-small")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.textTruncate(
                                                          subItem.title
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mb-1 ml-1",
                                                      attrs: {
                                                        small: ""
                                                      }
                                                    },
                                                    [_vm._v("mdi-open-in-new")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                ]
                              }
                            )
                          ],
                          2
                        )
                      ]
                    : [
                        _c(
                          "v-list-item",
                          {
                            key: item.path,
                            staticClass: "my-2",
                            attrs: {
                              to: item.to,
                              exact: item.exact,
                              ripple: false
                            },
                            on: {
                              click: function click($event) {
                                item.onClick
                                  ? _vm.menuClick(item.onClick, [
                                      _vm.serviceId,
                                      _vm.$route.query.user
                                    ]) && _vm.cleanGroup()
                                  : _vm.cleanGroup()
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c(
                                  "v-list-item-title",
                                  [
                                    item.action
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-2"
                                          },
                                          [_vm._v(_vm._s(item.action))]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "fs-14 font-weight-medium"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.textTruncate(item.title)
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    item.icon
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "pl-2",
                                            attrs: {
                                              small: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.icon) + " "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                ]
              })
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }